import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './about2.css';
import about2 from '../Imges/OurStory.jpeg';

const Second = () => {
  // Ref for tracking when the section is in view
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.3, once: false });

  return (
    <div className="capabilities-container" ref={ref}>
      {/* Section Title */}
      <h2 className="section-title">
        <span className="title-bar">|</span> OUR STORY <span className="title-bar">|</span>
      </h2>

      <div className="capabilities-content">
        {/* Left side image */}
        <motion.div 
          className="capabilities-image"
          initial={{ opacity: 0, x: -100 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
          transition={{ duration: 1 }}
        >
          <img
            src={about2}
            alt="Creative Workspace"
          />
        </motion.div>

        {/* Right side animated text content */}
        <motion.div 
          className="capabilities-text"
          initial={{ opacity: 0, x: 100 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 100 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            style={{color: 'black'}}
          >
            | <strong>DIVYAM ADS CAPABILITIES</strong> |
          </motion.h2>

          {/* Animated paragraphs */}
          {[ 
            "DIVYAM ADS, A FULLY FORMED ADVERTISEMENT AGENCY is recognized as a leader in Advertisement which is driven by Valuable Creativity & Services.",
            "We meet deadlines. We exceed expectations. We keep people happy by doing the little things right and the big things better.",
            "Our lean, homegrown team is filled with passionate people who have refined their respective marketing crafts. Experience has taught us what works, but it has also taught us that there is always a better way. Pursuit of the 'better way' is what keeps us up at night and at the top of our game.",
            "Divyam Ads provides integrated branding solutions through powerful & Creative strategies."
          ].map((text, index) => (
            <motion.p
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.8, delay: 0.6 + index * 0.2 }}
            >
              {text}
            </motion.p>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Second;
